import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Grid, TextField, MenuItem, Card, CardContent, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { makeApiRequest } from '../../../utils/api';

function Basics({ formData, handleFormDataChange, setValue }) {
    const control = localStorage.getItem('control');
    const [fileName, setFileName] = useState('');
    const [batchList, setBatchList] = useState([]);
    const [courseList, setCourseList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reportList,setReportList]=useState([])

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                toast.warn('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }

            setFileName(file.name);
            const base64 = await convertToBase64(file);
            handleFormDataChange('basic', {
                ...formData.basic,
                image: base64,
            });
        }
    };

    const handleBasicChange = (field) => (event) => {
        handleFormDataChange('basic', {
            ...formData.basic,
            [field]: event.target.value,
        });
    };

    const handleBatchChange = (event) => {
        const selectedBatchId = event.target.value;
        const selectedBatch = batchList.find((batch) => batch.id === selectedBatchId);
        handleFormDataChange('basic', {
            ...formData.basic,
            batch_id: selectedBatchId,
            batch: selectedBatch?.batch_name || '',
            mode: selectedBatch?.mode ? selectedBatch.mode.toLowerCase() : formData.basic?.mode,
        });
    };

    const filteredBatchList = (formData.basic?.mode && !formData.basic?.batch_id)
        ? batchList.filter((batch) => batch.mode?.toLowerCase() === formData.basic.mode)
        : batchList;


    const handleAddressChange = (field) => (event) => {
        if (field === 'addr') {
            handleFormDataChange('basic', {
                ...formData.basic,
                addr: event.target.value
            });
        } else if (field === 'paddr') {
            handleFormDataChange('basic', {
                ...formData.basic,
                paddr: event.target.value
            });
        }
    };

    const handleDateChange = (event) => {
        handleFormDataChange('basic', {
            ...formData.basic,
            org_doj: event.target.value
        });
    };
    const handleNext = () => {
        setValue('Personal Information');
    };
    const locationMapping = {
        "Chennai": "1",
        "Trichy": "2",
    };
    useEffect(() => {
        const fetchCourseData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await makeApiRequest('post', '/api/course/list', {
                    token: localStorage.getItem('authToken'),
                });
                if (!response || response.status !== 'success' || !response.data) {
                    throw new Error(response?.message || 'Invalid response from API');
                }
                setCourseList(response.data);
            }
            catch (err) {
                console.error("Error fetching batches:", err);
                setError(err.message || 'Error fetching data');
                setCourseList([]);
            } finally {
                setLoading(false);
            }
        };
        fetchCourseData();
    }, []);

    useEffect(() => {
        const fetchBatchData = async () => {
            if (batchList.length > 0) return;

            setLoading(true);
            setError(null);
            try {
                const response = await makeApiRequest('post', '/api/listBatches/active', {
                    token: localStorage.getItem('authToken'),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                });

                if (!response || response.status !== 'success' || !response.data) {
                    throw new Error(response?.message || 'Invalid response from API');
                }

                const responseData = response.data;

                // if ( !Array.isArray(responseData.batches)) {
                //     throw new Error(responseData.message || 'Batch data format is incorrect');
                // }

                setBatchList(responseData);
            } catch (err) {
                console.error("Error fetching batches:", err);
                setError(err.message || 'Error fetching data');
                setBatchList([]);
            } finally {
                setLoading(false);
            }
        };
        fetchBatchData();
    }, []);
    useEffect(() => {
        const fetchReportTo = async () => {
            if (batchList.length > 0) return;

            setLoading(true);
            setError(null);
            try {
                const response = await makeApiRequest('post', '/api/employee/reportTo', {
                    token: localStorage.getItem('authToken'),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                });


                if (!response || response.status !== 'success' || !response.data) {
                    throw new Error(response?.message || 'Invalid response from API');
                }

                const responseData = response.data;

                setReportList(responseData);
            } catch (err) {
                console.error("Error fetching batches:", err);
                setError(err.message || 'Error fetching data');
                setReportList([]);
            } finally {
                setLoading(false);
            }
        };
        fetchReportTo();
    }, []);


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Card sx={{ margin: 2 }}>
                <CardContent>
                    <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                        <strong style={{ fontWeight: 600 }}>Basic details</strong>
                    </Typography>
                    <Grid container spacing={5.5}>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="First Name"
                                name="name"
                                value={formData.basic?.name || ''}
                                onChange={handleBasicChange('name')}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Last Name"
                                name="name2"
                                value={formData.basic?.name2 || ''}
                                onChange={handleBasicChange('name2')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Employee ID"

                                name="username"
                                value={formData.basic?.username || ''}
                                onChange={handleBasicChange('username')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Phone Number"
                                name="phoneno"
                                value={formData.basic?.phoneno || ''}
                                onChange={handleBasicChange('phoneno')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Location"
                                name="location"
                                select
                                value={formData.basic?.location || ''}
                                onChange={handleBasicChange('location')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <MenuItem value="1">Chennai</MenuItem>
                                <MenuItem value="2">Trichy</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Type"
                                name="emp_type"
                                select
                                value={formData.basic?.emp_type || ''}
                                onChange={handleBasicChange('emp_type')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <MenuItem value="2">Staff</MenuItem>
                                <MenuItem value="3">Student</MenuItem>
                                {control == 1 && <MenuItem value="4">Branch Admin</MenuItem>}
                            </TextField>

                        </Grid>
                        
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Batch"
                                name="batch_id"
                                select
                                value={formData.basic?.batch_id || ''}
                                onChange={handleBatchChange}
                                // onClick={fetchBatchData}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                {formData.basic?.batch_id && !filteredBatchList.some((batch) => batch.id === formData.basic?.batch_id) && (
                                    <MenuItem value={formData.basic?.batch_id} disabled>
                                        {formData.basic?.batch || "--"}
                                    </MenuItem>
                                )}

                                {error ? (
                                    <MenuItem disabled>{error}</MenuItem>
                                ) : filteredBatchList.length > 0 ? (

                                    filteredBatchList.map((batch) => (
                                        <MenuItem key={batch.id} value={batch.id}>
                                            {batch.batch_name}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled> -- </MenuItem>
                                )}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Course"
                                name="course_id"
                                select
                                value={formData.basic?.course_id || ''}
                                onChange={handleBasicChange('course_id')}
                                // onClick={fetchCourseData}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                {formData.basic?.course_id && courseList.length > 0 && (
                                    <MenuItem value={formData.basic?.course_id} disabled>
                                        {formData.basic?.course || "--"}
                                    </MenuItem>
                                )}
                                {error ? (
                                    <MenuItem disabled>{error}</MenuItem>
                                ) : courseList.length > 0 ? (
                                    courseList.filter(course => course.id > 0)
                                        .map((course) => (
                                            <MenuItem key={course.id} value={course.id}>
                                                {course.course_name}
                                            </MenuItem>
                                        ))
                                ) : (
                                    <MenuItem disabled> -- </MenuItem>
                                )}
                            </TextField>
                        </Grid>
                        {formData.basic?.emp_type === "3" && (
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <TextField
                                    required
                                    label="Mode"
                                    name="mode"
                                    select
                                    value={formData.basic?.mode || ''}
                                    onChange={handleBasicChange('mode')}
                                    disabled={!!formData.basic?.batch_id}
                                    InputLabelProps={{ shrink: true }}
                                    size='small'
                                    sx={{
                                        width: "100%",
                                        '& .MuiFormLabel-asterisk': {
                                            color: 'red',
                                        },
                                    }}
                                >
                                    <MenuItem value="offline">Offline</MenuItem>
                                    <MenuItem value="online">Online</MenuItem>
                                </TextField>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Employment Type"
                                name="etype"
                                select
                                value={formData.basic?.etype || ''}
                                onChange={handleBasicChange('etype')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <MenuItem value="Full Time">Full Time</MenuItem>
                                <MenuItem value="Part Time">Part Time</MenuItem>
                                <MenuItem value="Weekend">Weekend</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Department"
                                name="department"
                                select
                                value={formData.basic?.department || ''}
                                onChange={handleBasicChange('department')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <MenuItem value="1">Architecture</MenuItem>
                                <MenuItem value="6">Chemical</MenuItem>
                                <MenuItem value="3">Civil</MenuItem>
                                <MenuItem value="4">Electrical</MenuItem>
                                <MenuItem value="9">L&D</MenuItem>
                                <MenuItem value="2">Mechanical</MenuItem>
                                <MenuItem value="7">Petrochemical</MenuItem>
                                <MenuItem value="8">Petroleum</MenuItem>
                                <MenuItem value="5">Structural</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Date of Joining"
                                name="org_doj"
                                type="date"
                                value={formData.basic?.org_doj || ''}
                                onChange={handleDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                size='small'
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-input": {
                                        color: formData.basic?.org_doj ? "#000" : "#a2a2a2", // Black when date is selected, Gray otherwise
                                    },
                                    "& input::-webkit-datetime-edit-text": {
                                        color: "#a2a2a2", // Placeholder color
                                    },
                                    "& input::-webkit-datetime-edit-year-field, \
                                       & input::-webkit-datetime-edit-month-field, \
                                       & input::-webkit-datetime-edit-day-field": {
                                        color: formData.basic?.org_doj ? "#000" : "#a2a2a2", // Black when date is selected
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                        color: "red", // Red asterisk for required fields
                                    },
                                }}
                            />

                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                label="Qural Experience"
                                name="conserv_exp"
                                value={formData.basic?.conserv_exp || ''}
                                onChange={handleBasicChange('conserv_exp')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                // required
                                label="Employee Status"
                                name="estatus"
                                select
                                value={formData.basic?.estatus || 'active'}
                                onChange={handleBasicChange('estatus')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            >
                                <MenuItem value="Active">Active</MenuItem>
                                <MenuItem value="Completed">Completed</MenuItem>
                                <MenuItem value="Abscond">Abscond</MenuItem>
                                <MenuItem value="Terminated">Terminated</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                label="Reporting To"
                                placeholder="Enter the userid of reporting person"
                                name="reportto"
                                select
                                value={formData.basic?.reportto || ''}
                                onChange={handleBasicChange('reportto')}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                sx={{
                                width: "100%",
                                }}
                            >{formData.basic?.reportto && reportList.length > 0 && (
                                <MenuItem value={formData.basic?.reportto} disabled>
                                    {reportList.find(person => person.id === formData.basic?.reportto)?.name || "--"}
                                </MenuItem>
                            )}
                            {error ? (
                                <MenuItem disabled>{error}</MenuItem>
                            ) : reportList.length > 0 ? (
                                reportList.filter(item => item.id > 0)
                                    .map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    ))
                            ) : (
                                <MenuItem disabled> -- </MenuItem>
                            )}
                            </TextField>
                        </Grid>


                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                label="Shift"
                                name="shift"
                                select
                                value={formData.basic?.shift || ''}
                                onChange={handleBasicChange('shift')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            >
                                <MenuItem value="09:00:00">Day</MenuItem>
                                <MenuItem value="18:30:00">Night</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <input
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                                id="profile-upload"
                            />
                            <label htmlFor="profile-upload">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<CloudUploadIcon />}
                                    size='medium'
                                    sx={{
                                        width: "100%",
                                        padding: '7px 0px',
                                    }}
                                >
                                    {fileName || formData?.personal?.image || 'Upload proflie'}
                                </Button>
                            </label>
                            {formData.basic?.image && (
                                <Typography variant="caption" display="block" sx={{ mt: 1, color: 'green' }}>
                                    File saved successfully
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card sx={{ margin: 2 }}>
                <CardContent>
                    <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                        <strong style={{ fontWeight: 600 }}>Address</strong>
                    </Typography>
                    <Grid container spacing={5.5}>
                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            <TextField
                                // required
                                label="Residential Address"
                                name="addr"
                                multiline
                                rows={4}
                                value={formData.basic?.addr || ''}
                                onChange={handleAddressChange('addr')}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    width: "100%",
                                    '& .MuiOutlinedInput-root': { padding: '0px' },
                                    '& .MuiInputBase-input': {
                                        padding: '14px',
                                        lineHeight: '24px',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            <TextField
                                // required
                                label="Permanent Address"
                                name="paddr"
                                multiline
                                rows={4}
                                value={formData.basic?.paddr || ''}
                                onChange={handleAddressChange('paddr')}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    width: "100%",
                                    '& .MuiOutlinedInput-root': { padding: '0px' },
                                    '& .MuiInputBase-input': {
                                        padding: '14px',
                                        lineHeight: '24px',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ height: "80px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="contained"
                                    endIcon={<ArrowForwardIcon />}
                                    onClick={handleNext}
                                >
                                    Next
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default Basics;